import { NgModule } from '@angular/core';
import { InfoFieldItemComponent } from './info-field-item/info-field-item.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../common/pipes/pipes.module';
import { TimezoneModule } from '../timezone/timezone.module';
import { InfoFieldListComponent } from './info-field-list/info-field-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '../../common/directives/directives.module';
import { InfoFieldItemValueListComponent } from './info-field-item-value-list/info-field-item-value-list.component';
import { InfoFieldDatesWithDividerComponent } from './info-field-dates-with-divider/info-field-dates-with-divider.component';
import { DatesWithDividerModule } from '../dates-with-divider/dates-with-divider.module';
import { InfoFieldExpandableValueListComponent } from './info-field-expandable-value-list/info-field-expandable-value-list.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { InfoFieldExpandableValueListDirective } from './info-field-expandable-value-list/info-field-expandable-value-list.directive';

@NgModule({
  declarations: [
    InfoFieldItemComponent,
    InfoFieldListComponent,
    InfoFieldItemValueListComponent,
    InfoFieldDatesWithDividerComponent,
    InfoFieldExpandableValueListComponent,
    InfoFieldExpandableValueListDirective,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    PipesModule,
    TimezoneModule,
    TranslateModule,
    DirectivesModule,
    DatesWithDividerModule,
    SvgIconModule,
    DirectivesModule,
  ],
  exports: [
    InfoFieldItemComponent,
    InfoFieldListComponent,
    InfoFieldItemValueListComponent,
    InfoFieldDatesWithDividerComponent,
    InfoFieldExpandableValueListComponent,
  ],
})
export class InfoFieldModule {}
